import React, { FC } from 'react';
import styles from './icons.module.scss';

const IconClose: FC = () => <img src="/images/icon_close.svg" alt="remove filter" className={styles.icon} />;

export default IconClose;
